import propTypes from 'prop-types';
import React from 'react';
import * as theme from '../constants/theme';

const {GUTTER, WIDTH} = theme;

const Container = ({children, width, direction, ...props}) => {
	return (
		<div style={{maxWidth: width, flexDirection: direction, ...props.styles}} {...props}>
			{children}
			<style jsx>
				{`
					div {
						display: flex;
						align-items: center;
						margin: 0 auto;
						padding-left: ${GUTTER};
						padding-right: ${GUTTER};
						width: 100%;
						max-width: ${WIDTH};
					}
				`}
			</style>
		</div>
	);
};

Container.propTypes = {
	children: propTypes.any,
	width: propTypes.string,
	direction: propTypes.string,
	styles: propTypes.any
};

export default Container;



// WEBPACK FOOTER //
// components/container.js